<template>
  <div id="app">
    <!-- Authenticated layout: left nav + main content + right quick-search drawer -->
    <Sidebar v-if="showSidebar" :forced-collapsed="rightDrawerOpen">
      <div class="app-main-layout">
        <div
          class="app-main-layout__content"
          :class="{ 'app-main-layout__content--with-drawer': rightDrawerOpen }"
        >
          <router-view />
        </div>
        <RightSearchDrawer
          @drawer-open="rightDrawerOpen = true"
          @drawer-close="rightDrawerOpen = false"
        />
      </div>
    </Sidebar>

    <!-- Public layout: simple content without sidebars -->
    <router-view v-else />

    <Toast />
  </div>
</template>

<script>
import Sidebar from './components/Sidebar.vue';
import RightSearchDrawer from './components/RightSearchDrawer.vue';
import Toast from 'primevue/toast';

export default {
  name: 'App',
  components: {
    Sidebar,
    RightSearchDrawer,
    Toast
  },
  data() {
    return {
      rightDrawerOpen: false
    };
  },
  computed: {
    showSidebar() {
      return this.$route.meta.requiresAuth === true;
    }
  },
  watch: {
    showSidebar: {
      immediate: true,
      handler(useShellScroll) {
        document.documentElement.classList.toggle(
          'app-shell-scroll-lock',
          Boolean(useShellScroll)
        );
      },
    },
  },
  beforeUnmount() {
    document.documentElement.classList.remove('app-shell-scroll-lock');
  },
};
</script>

<style>
.app-main-layout {
  display: flex;
  min-height: 100%;
}

.app-main-layout__content {
  flex: 1;
  min-width: 0;
  min-height: 0;
}

.app-main-layout__content--with-drawer {
  margin-right: 380px; /* match open drawer width */
  transition: margin-right 0.25s ease-in-out;
}
</style>

